import moment from "moment";

export interface Measure {
  code: string;
  display: string;
  description: string;
}

export interface Detraction {
  code: string;
  description: string;
  percent: number;
}

export interface MotivoTraslado {
  value: string;
  label: string;
  shippingTypeValue: string;
}

export interface TaxConcept {
  value: string;
  label: string;
}

export interface PortAirport {
  title: string;
  code: string;
  name: string;
}

export const measureList: Array<Measure> = [
  { code: "NIU", display: "UND", description: "Unidades" },
  { code: "ZZ", display: "ZZ", description: "Servicios" },
  { code: "BX", display: "CJ", description: "Cajas" },
  { code: "MTR", display: "MT", description: "Metros" },
  { code: "KGM", display: "KG", description: "Kilogramos" },
  { code: "MGM", display: "MG", description: "Miligramos" },
  { code: "GRM", display: "G", description: "Gramos" },
  { code: "TNE", display: "TN", description: "Toneladas" },
  { code: "LTR", display: "LT", description: "Litros" },
  { code: "MLT", display: "ML", description: "Mililitros" },
  { code: "GLL", display: "GL", description: "Galones" },
  { code: "ONZ", display: "OZ", description: "Onzas" },
  { code: "LBR", display: "LB", description: "Libras" },
  { code: "CMT", display: "CM", description: "Centimetros" },
  { code: "ZZ", display: "ZZ", description: "Servicios" },
];

export const taxConceptList: Array<TaxConcept> = [
  { value: "7020", label: "Partida arancelaria"},
  { value: "7021", label: "Numero de declaración aduanera (DAM)"},
  { value: "7022", label: "Indicador de bien normalizado"},
  { value: "7023", label: "Numero de serie en la DAM o DS"},
  { value: "Otros", label: "Especificar!"}
];

export const relatedDocumentsList: Array<MotivoTraslado> = [
  { shippingTypeValue: "01", value: "01", label: "Factura" },
  { shippingTypeValue: "01", value: "03", label: "Boleta de Venta" },
  {
    shippingTypeValue: "01",
    value: "09",
    label: "Guía de Remisión Remitente",
  },
  {
    shippingTypeValue: "01",
    value: "12",
    label: "Ticket o cinta emitido por máquina registradora",
  },
  {
    shippingTypeValue: "01",
    value: "49",
    label: "Constancia de Depósito - IVAP (Ley 28211)",
  },
  {
    shippingTypeValue: "01",
    value: "80",
    label: "Constancia de Depósito - Detracción",
  },
  {
    shippingTypeValue: "01",
    value: "81",
    label: "Código de autorización emitida por el SCOP",
  },

  { shippingTypeValue: "02", value: "01", label: "Factura" },
  { shippingTypeValue: "02", value: "03", label: "Boleta de Venta" },
  { shippingTypeValue: "02", value: "04", label: "Liquidación de Compra" },
  {
    shippingTypeValue: "02",
    value: "12",
    label: "Ticket o cinta emitido por máquina registradora",
  },
  {
    shippingTypeValue: "02",
    value: "48",
    label: "Comprobante de Operaciones - Ley N° 29972",
  },
  {
    shippingTypeValue: "02",
    value: "49",
    label: "Constancia de Depósito - IVAP (Ley 28211)",
  },
  {
    shippingTypeValue: "02",
    value: "80",
    label: "Constancia de Depósito - Detracción",
  },
  {
    shippingTypeValue: "02",
    value: "81",
    label: "Código de autorización emitida por el SCOP",
  },

  { shippingTypeValue: "03", value: "01", label: "Factura" },
  { shippingTypeValue: "03", value: "03", label: "Boleta de Venta" },
  { shippingTypeValue: "03", value: "04", label: "Liquidación de Compra" },
  {
    shippingTypeValue: "03",
    value: "09",
    label: "Guía de Remisión Remitente",
  },
  {
    shippingTypeValue: "03",
    value: "12",
    label: "Ticket o cinta emitido por máquina registradora",
  },
  {
    shippingTypeValue: "03",
    value: "48",
    label: "Comprobante de Operaciones - Ley N° 29972",
  },
  {
    shippingTypeValue: "03",
    value: "49",
    label: "Constancia de Depósito - IVAP (Ley 28211)",
  },
  {
    shippingTypeValue: "03",
    value: "81",
    label: "Código de autorización emitida por el SCOP",
  },

  {
    shippingTypeValue: "04",
    value: "80",
    label: "Constancia de Depósito - Detracción",
  },
  {
    shippingTypeValue: "04",
    value: "81",
    label: "Código de autorización emitida por el SCOP",
  },

  {
    shippingTypeValue: "05",
    value: "09",
    label: "Guía de Remisión Remitente",
  },
  {
    shippingTypeValue: "05",
    value: "49",
    label: "Constancia de Depósito - IVAP (Ley 28211)",
  },
  {
    shippingTypeValue: "05",
    value: "80",
    label: "Constancia de Depósito - Detracción",
  },
  {
    shippingTypeValue: "05",
    value: "81",
    label: "Código de autorización emitida por el SCOP",
  },

  { shippingTypeValue: "06", value: "01", label: "Factura" },
  { shippingTypeValue: "06", value: "03", label: "Boleta de Venta" },
  { shippingTypeValue: "06", value: "04", label: "Liquidación de Compra" },
  {
    shippingTypeValue: "06",
    value: "12",
    label: "Ticket o cinta emitido por máquina registradora",
  },
  {
    shippingTypeValue: "06",
    value: "80",
    label: "Constancia de Depósito - Detracción",
  },
  {
    shippingTypeValue: "06",
    value: "81",
    label: "Código de autorización emitida por el SCOP",
  },

  { shippingTypeValue: "07", value: "01", label: "Factura" },
  { shippingTypeValue: "07", value: "03", label: "Boleta de Venta" },
  { shippingTypeValue: "07", value: "04", label: "Liquidación de Compra" },
  {
    shippingTypeValue: "07",
    value: "12",
    label: "Ticket o cinta emitido por máquina registradora",
  },
  {
    shippingTypeValue: "07",
    value: "80",
    label: "Constancia de Depósito - Detracción",
  },

  {
    shippingTypeValue: "08",
    value: "09",
    label: "Guía de Remisión Remitente",
  },
  {
    shippingTypeValue: "08",
    value: "49",
    label: "Constancia de Depósito - IVAP (Ley 28211)",
  },
  {
    shippingTypeValue: "08",
    value: "50",
    label: "Declaración Aduanera de Mercancías",
  },
  {
    shippingTypeValue: "08",
    value: "52",
    label: "Declaración Simplificada (DS)",
  },
  {
    shippingTypeValue: "08",
    value: "80",
    label: "Constancia de Depósito - Detracción",
  },

  {
    shippingTypeValue: "09",
    value: "09",
    label: "Guía de Remisión Remitente",
  },
  {
    shippingTypeValue: "09",
    value: "49",
    label: "Constancia de Depósito - IVAP (Ley 28211)",
  },
  {
    shippingTypeValue: "09",
    value: "50",
    label: "Declaración Aduanera de Mercancías",
  },
  {
    shippingTypeValue: "09",
    value: "52",
    label: "Declaración Simplificada (DS)",
  },
  {
    shippingTypeValue: "09",
    value: "80",
    label: "Constancia de Depósito - Detracción",
  },

  {
    shippingTypeValue: "14",
    value: "17",
    label: "Traslado de bienes para transformación",
  },
  {
    shippingTypeValue: "14",
    value: "18",
    label: "Traslado emisor itinerante CP",
  },

  { shippingTypeValue: "13", value: "01", label: "Factura" },
  { shippingTypeValue: "13", value: "03", label: "Boleta de Venta" },
  { shippingTypeValue: "13", value: "04", label: "Liquidación de Compra" },
  {
    shippingTypeValue: "13",
    value: "09",
    label: "Guía de Remisión Remitente",
  },
  {
    shippingTypeValue: "13",
    value: "12",
    label: "Ticket o cinta emitido por máquina registradora",
  },
  {
    shippingTypeValue: "13",
    value: "48",
    label: "Comprobante de Operaciones - Ley N° 29972",
  },
  {
    shippingTypeValue: "13",
    value: "49",
    label: "Constancia de Depósito - IVAP (Ley 28211)",
  },
  {
    shippingTypeValue: "13",
    value: "50",
    label: "Declaración Aduanera de Mercancías",
  },
  {
    shippingTypeValue: "13",
    value: "52",
    label: "Declaración Simplificada (DS)",
  },
  {
    shippingTypeValue: "13",
    value: "80",
    label: "Constancia de Depósito - Detracción",
  },
  {
    shippingTypeValue: "13",
    value: "81",
    label: "Código de autorización emitida por el SCOP",
  },
  {
    shippingTypeValue: "13",
    value: "71",
    label: "Resolución de Adjudicación de bienes - SUNAT",
  },
  {
    shippingTypeValue: "13",
    value: "72",
    label: "Resolución de Comiso de bienes - SUNAT",
  },
  {
    shippingTypeValue: "13",
    value: "73",
    label: "Guía de Transporte Forestal o de Fauna - SERFOR",
  },
  {
    shippingTypeValue: "13",
    value: "74",
    label: "Guía de Tránsito - SUCAMEC",
  },
  {
    shippingTypeValue: "13",
    value: "75",
    label:
      "Autorización para operar como empresa de Saneamiento Ambiental - MINSA",
  },
  {
    shippingTypeValue: "13",
    value: "76",
    label:
      "Autorización para manejo y recojo de residuos sólidos peligrosos y no peligrosos",
  },
  {
    shippingTypeValue: "13",
    value: "77",
    label:
      "Certificado fitosanitario la movilización de plantas, productos vegetales, y otros artículos reglamentados",
  },
  {
    shippingTypeValue: "13",
    value: "78",
    label: "Registro Único de Usuarios y Transportistas de Alcohol Etílico",
  },
];

export const portAirportList: Array<PortAirport> = [
  { title: "Puerto", code: "PUB", name: "Bayóvar" },
  { title: "Puerto", code: "CLL", name: "Callao" },
  { title: "Puerto", code: "CON", name: "Conchán" },
  { title: "Puerto", code: "CHY", name: "Chancay" },
  { title: "Puerto", code: "CHM", name: "Chimbote" },
  { title: "Puerto", code: "EEN", name: "Eten" },
  { title: "Puerto", code: "HCO", name: "Huacho" },
  { title: "Puerto", code: "HUY", name: "Huarmey" },
  { title: "Puerto", code: "ILQ", name: "Ilo" },
  { title: "Puerto", code: "IQT", name: "Iquitos" },
  { title: "Puerto", code: "MRI", name: "Matarani" },
  { title: "Puerto", code: "PAI", name: "Paita" },
  { title: "Puerto", code: "PIO", name: "Pisco" },
  { title: "Puerto", code: "PCL", name: "Pucallpa" },
  { title: "Puerto", code: "PUN", name: "Puno" },
  { title: "Puerto", code: "SVY", name: "Salaverry" },
  { title: "Puerto", code: "SNX", name: "San Nicolas" },
  { title: "Puerto", code: "SUP", name: "Supe" },
  { title: "Puerto", code: "TYL", name: "Talara" },
  { title: "Puerto", code: "YMS", name: "Yurimaguas" },
  { title: "Puerto", code: "ZOR", name: "Zorritos" },

  { title: "Aeropuerto", code: "AQP", name: "Rodríguez Ballón" },
  { title: "Aeropuerto", code: "ANS", name: "Andahuaylas" },
  {
    title: "Aeropuerto",
    code: "ATA",
    name: "Comandante FAP Germán Arias Graciani",
  },
  {
    title: "Aeropuerto",
    code: "AYP",
    name: "Coronel FAP Alfredo Mendívil Duarte",
  },
  {
    title: "Aeropuerto",
    code: "CJA",
    name: "Mayor Gral. FAP Armando Revoredo Iglesias",
  },
  {
    title: "Aeropuerto",
    code: "CHM",
    name: "Tnte. FAP Jaime De Montruil M.",
  },
  { title: "Aeropuerto", code: "CUZ", name: "Alejandro Velazco Astete" },
  { title: "Aeropuerto", code: "CHH", name: "Chachapoyas" },
  { title: "Aeropuerto", code: "CIX", name: "Capitán FAP José Quiñones G." },
  {
    title: "Aeropuerto",
    code: "HUU",
    name: "Alférez FAP David Figueroa Fernandini",
  },
  { title: "Aeropuerto", code: "ILO", name: "Ilo" },
  {
    title: "Aeropuerto",
    code: "IQT",
    name: "Coronel FAP Francisco Secada Vignetta",
  },
  { title: "Aeropuerto", code: "JAE", name: "Jaén - Shumba" },
  { title: "Aeropuerto", code: "JJI", name: "Juanjuí" },
  { title: "Aeropuerto", code: "JUL", name: "Manco Cápac" },
  { title: "Aeropuerto", code: "JAU", name: "Francisco Carlé" },
  { title: "Aeropuerto", code: "LIM", name: "Internacional Jorge Chávez" },
  { title: "Aeropuerto", code: "MBP", name: "Moyobamba" },
  {
    title: "Aeropuerto",
    code: "PIO",
    name: "Capitán FAP Renán Elías Olivera",
  },
  {
    title: "Aeropuerto",
    code: "PIU",
    name: "Capitán FAP Carlos Concha Iberico",
  },
  {
    title: "Aeropuerto",
    code: "PCL",
    name: "Capitán FAP David Abensur Rengifo",
  },
  { title: "Aeropuerto", code: "PEM", name: "Padre Aldamiz" },
  { title: "Aeropuerto", code: "RIJ", name: "Juan Simons Vela - Rioja" },
  {
    title: "Aeropuerto",
    code: "TCQ",
    name: "Coronel FAP Carlos Ciriani Santa Rosa",
  },
  { title: "Aeropuerto", code: "TYL", name: "Capitán FAP Montes Arias" },
  {
    title: "Aeropuerto",
    code: "TPP",
    name: "Cadete FAP Guillermo del Castillo Paredes",
  },
  { title: "Aeropuerto", code: "TIG", name: "Tingo María" },
  {
    title: "Aeropuerto",
    code: "TRU",
    name: "Capitán FAP Carlos Martínez Pinillos",
  },
  {
    title: "Aeropuerto",
    code: "TBP",
    name: "Capitán FAP Pedro Canga Rodríguez",
  },
  {
    title: "Aeropuerto",
    code: "ATG",
    name: "Atalaya - Tnte. Gral. Gerardo Pérez Pinedo",
  },
  { title: "Aeropuerto", code: "YMS", name: "Moisés Benzaquen Rengifo" },
];

export const detractionList: Array<Detraction> = [
  { code: "016", description: "Aceite de pescado", percent: 10 },
  { code: "013", description: "Animales vivos", percent: 10 },
  { code: "009", description: "Arena y piedra.", percent: 15 },
  { code: "001", description: "Azúcar y melaza de caña", percent: 10 },
  { code: "006", description: "Algodón", percent: 10 },
  { code: "035", description: "Bienes exonerados del IGV", percent: 4 },
  { code: "007", description: "Caña de azúcar", percent: 4 },
  { code: "024", description: "Comisión mercantil", percent: 1.5 },
  { code: "037", description: "Demás servicios gravados con el IGV", percent: 12 },
  { code: "025", description: "Fabricación de bienes por encargo", percent: 10 },
  { code: "012", description: "Intermediación laboral y tercerización", percent: 4 },
  { code: "008", description: "Madera", percent: 10 },
  { code: "005", description: "Maíz amarillo duro", percent: 4 },
  { code: "039", description: "Minerales no metálicos", percent: 10 },
  { code: "031", description: "Oro gravado con el IGV", percent: 10 },
  { code: "022", description: "Otros servicios empresariales", percent: 12 },
  { code: "041", description: "Plomo", percent: 1.5 },
  { code: "004", description: "Recursos hidrobiológicos", percent: 4 },
  { code: "026", description: "Servicio de transporte de personas", percent: 10 },
  { code: "015", description: "Abonos, cueros y pieles de origen animal", percent: 10 },
  { code: "003", description: "Alcohol etílico", percent: 10 },
  { code: "019", description: "Arrendamiento de bienes muebles", percent: 10 },
  { code: "002", description: "Arroz", percent: 1.5 },
  { code: "029", description: "Algodón en rama sin desmontar", percent: 4 },
  { code: "040", description: "Bien inmueble gravado con IGV", percent: 4 },
  {
    code: "011",
    description: "Bienes gravados con el IGV, o renuncia a la exoneración",
    percent: 4,
  },
  { code: "014", description: "Carnes y despojos comestibles", percent: 10 },
  { code: "030", description: "Contratos de construcción", percent: 10 },
  {
    code: "017",
    description:
      "Harina, polvo y “pellets” de pescado, crustáceos, moluscos y demás invertebrados acuáticos",
    percent: 10,
  },
  {
    code: "018",
    description: "Embarcaciones pesqueras",
    percent: 10,
  },
  { code: "023", description: "Leche", percent: 1.5 },
  { code: "099", description: "Ley 30737", percent: 1.5 },
  { code: "020", description: "Mantenimiento y reparación de bienes muebles", percent: 4 },
  { code: "034", description: "Minerales metálicos no auríferos", percent: 10 },
  { code: "021", description: "Movimiento de carga", percent: 10 },
  { code: "036", description: "Oro y demás minerales metálicos exonerados del IGV", percent: 10 },
  { code: "033", description: "Espárragos", percent: 4 },
  {
    code: "032",
    description: "Paprika y otros frutos de los generos capsicum o pimienta",
    percent: 4,
  },
  {
    code: "010",
    description: "Residuos, subproductos, desechos, recortes y desperdicios",
    percent: 10,
  },
  { code: "027", description: "Servicio de transporte de carga", percent: 1.5 },
  { code: "028", description: "Transporte de pasajeros", percent: 1.5 },
];

export const validateEmail = (email: string) => {
  let re: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const isValidTelephoneNumber = (phoneNumber: string) => {
  let re: RegExp = /^(\+\d{1,2}\s)?\(?\d{2,3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  return re.test(phoneNumber);
};

export const getIDDocumentType = (code: string) => {
  switch (code) {
    case "6":
      return "RUC";
    case "0":
      return "Doc.trib.no.dom.sin.ruc";
    case "1":
      return "DNI";
    case "4":
      return "Carnet de extranjería";
    case "7":
      return "Pasaporte";
    case "A":
      return "Cedula Diplomática de identidad";
    case "B":
      return "DI de país residencia-no.d";
    case "C":
      return "TIN – Documento Tributario PP.NN";
    case "D":
      return "IN – Documento Tributario PP.JJ";
    case "E":
      return "TAM - Tarjeta Andina de Migración";
    default:
      return "";
  }
};

export const isValidRUC = (ruc: string) => {
  ruc = ruc.trim();
  if (Number(ruc) && ruc.length === 11) {
    let suma = 0;
    let x = 6;

    for (let i = 0; i < ruc.length - 1; i++) {
      if (i === 4) {
        x = 8;
      }
      x--;
      suma += Number(ruc.charAt(i)) * x;
    }

    let resto = suma % 11;
    resto = 11 - resto;

    if (resto >= 10) resto = resto - 10;
    if (resto === Number(ruc.charAt(ruc.length - 1))) {
      return true;
    }
  }
  return false;
};

export const isValidDNI = (dni: string) => {
  return Number.isInteger(Number(dni)) && dni.length === 8;
};

export const truncateString = (str: string, num: number) => {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + "...";
};

export const getCurrencySymbol = (code: string) => {
  switch (code) {
    case "PEN":
      return "S/";
    case "USD":
      return "$";
    default:
      return "";
  }
};

export const getDocumentTypeDesc = (code: string) => {
  switch (code) {
    case "03":
      return "Boleta";
    case "01":
      return "Factura";
    case "07":
      return "Nota de Crédito";
    case "08":
      return "Nota de Débito";
    case "09":
      return "Guía de remisión";
      case "20":
      return "Retención";
      case "40":
      return "Percepción";
    default:
      return "";
  }
};

export const getDocumentStatusDescription = (code: string) => {
  switch (code) {
    case "0":
      return "Pendiente de envío";
    case "1":
    case "3":
      return "Autorizado";
    case "2":
      return "Anulado";
    case "4":
      return "No autorizado";
    case "5":
      return "Pendiente de baja";
    case "-1":
      return "Erróneo";
    case "-2":
      return "Rechazado";
    default:
      return "";
  }
};

export const getEmailStatusDesc = (code: number) => {
  switch (code) {
    case 1:
      return "ENVIADO";
    case 2:
      return "RECIBIDO";
    case 3:
      return "LEÍDO";
    case -1:
      return "ERRÓNEO";
    case -2:
      return "RECHAZADO";
    default:
      return "";
  }
};

export const getCreditNoteReason = (code: string) => {
  switch (code) {
    case "01":
      return "Anulación de la Operación";
    case "02":
      return "Anulación por error en el RUC";
    case "03":
      return "Corrección por error en la descripción";
    case "04":
      return "Descuento global";
    case "05":
      return "Descuento por Item";
    case "06":
      return "Devolución total";
    case "07":
      return "Devolución parcial";
    default:
      return "";
  }
};

export const getDebitNoteReason = (code: string) => {
  switch (code) {
    case "01":
      return "Intereses por mora";
    case "02":
      return "Aumento en el valor";
    case "03":
      return "Penalidades/ otros conceptos";
    case "11":
      return "Ajustes de operaciones de exportación";
    case "12":
      return "Ajustes afectos al IVAP";
    default:
      return "";
  }
};

export const getReceiverFullAddress = (objAddress: any) => {
  let address = objAddress.address_line;
  let regCity: RegExp = /^\s*[a-zA-Z]{1}[0-9a-zA-Z][0-9a-zA-Z '-.=#/]*$/;
  if (objAddress.department && regCity.test(objAddress.department)) {
    address += `, ${objAddress.department}`;
  }
  if (objAddress.province && regCity.test(objAddress.province)) {
    address += `, ${objAddress.province}`;
  }
  if (objAddress.district && regCity.test(objAddress.district)) {
    address += `, ${objAddress.district}`;
  }
  return address;
};

export const numberWithCommas = (num: number) => {
  if (!num) return "0.00";
  let parts = num.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  parts[1] = parts[1] === undefined ? "00" : parts[1].length === 1 ? `${parts[1]}0` : parts[1];
  return parts.join(".");
};

export const parseDecimalNumber = (num: string) => {
  if (!num.includes(".")) {
    return `${num}.00`;
  } else {
    let parts = num.split(".");
    return parts[1].length === 1 ? `${parts[0]}.${parts[1]}0` : num;
  }
};

export const incrementSequential = (s: string) => {
  var [left, right = "0"] = s.split(/(\d*$)/),
    length = right.length;
  return left + (+right + 1).toString().padStart(length, "0");
};

export const timeout = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const getUnidadMedida = (code: string) => {
  const unidad = measureList.find((u) => u.code === code);
  return unidad ? unidad.display : code;
};

export const getUnidadMedidaDescripcion = (code: string) => {
  const unidad = measureList.find((u) => u.code === code);
  return unidad ? unidad.description : code;
};

/*
 * Funcionalidades para generar números en letras
 * */

function Unidades(num: number) {
  switch (num) {
    case 1:
      return "UN";
    case 2:
      return "DOS";
    case 3:
      return "TRES";
    case 4:
      return "CUATRO";
    case 5:
      return "CINCO";
    case 6:
      return "SEIS";
    case 7:
      return "SIETE";
    case 8:
      return "OCHO";
    case 9:
      return "NUEVE";
  }

  return "";
}

function Decenas(num: number) {
  let decena = Math.floor(num / 10);
  let unidad = num - decena * 10;
  switch (decena) {
    case 1:
      switch (unidad) {
        case 0:
          return "DIEZ";
        case 1:
          return "ONCE";
        case 2:
          return "DOCE";
        case 3:
          return "TRECE";
        case 4:
          return "CATORCE";
        case 5:
          return "QUINCE";
        default:
          return "DIECI" + Unidades(unidad);
      }
    case 2:
      switch (unidad) {
        case 0:
          return "VEINTE";
        default:
          return "VEINTI" + Unidades(unidad);
      }
    case 3:
      return DecenasY("TREINTA", unidad);
    case 4:
      return DecenasY("CUARENTA", unidad);
    case 5:
      return DecenasY("CINCUENTA", unidad);
    case 6:
      return DecenasY("SESENTA", unidad);
    case 7:
      return DecenasY("SETENTA", unidad);
    case 8:
      return DecenasY("OCHENTA", unidad);
    case 9:
      return DecenasY("NOVENTA", unidad);
    case 0:
      return Unidades(unidad);
  }
}

function DecenasY(strSin: string, numUnidades: number) {
  if (numUnidades > 0) return strSin + " Y " + Unidades(numUnidades);

  return strSin;
}

function Centenas(num: number) {
  let centenas = Math.floor(num / 100);
  let decenas = num - centenas * 100;

  switch (centenas) {
    case 1:
      if (decenas > 0) return "CIENTO " + Decenas(decenas);
      return "CIEN";
    case 2:
      return "DOSCIENTOS " + Decenas(decenas);
    case 3:
      return "TRESCIENTOS " + Decenas(decenas);
    case 4:
      return "CUATROCIENTOS " + Decenas(decenas);
    case 5:
      return "QUINIENTOS " + Decenas(decenas);
    case 6:
      return "SEISCIENTOS " + Decenas(decenas);
    case 7:
      return "SETECIENTOS " + Decenas(decenas);
    case 8:
      return "OCHOCIENTOS " + Decenas(decenas);
    case 9:
      return "NOVECIENTOS " + Decenas(decenas);
  }

  return Decenas(decenas);
}

function Seccion(num: number, divisor: number, strSingular: string, strPlural: string) {
  let cientos = Math.floor(num / divisor);
  let resto = num - cientos * divisor;
  let letras = "";
  if (cientos > 0)
    if (cientos > 1) letras = Centenas(cientos) + " " + strPlural;
    else letras = strSingular;

  if (resto > 0) letras += "";

  return letras;
}

function Miles(num: number) {
  let divisor = 1000;
  let cientos = Math.floor(num / divisor);
  let resto = num - cientos * divisor;

  let strMiles = Seccion(num, divisor, "MIL", "MIL");
  let strCentenas = Centenas(resto);

  if (strMiles === "") return strCentenas;

  return strMiles + " " + strCentenas;
}

function Millones(num: number) {
  let divisor = 1000000;
  let cientos = Math.floor(num / divisor);
  let resto = num - cientos * divisor;

  let strMillones = Seccion(num, divisor, "UN MILLON", "MILLONES");
  let strMiles = Miles(resto);

  if (strMillones === "") return strMiles;

  return strMillones + " " + strMiles;
}

export const NumeroALetras = (num: number) => {
  var data = {
    numero: num,
    enteros: Math.floor(num),
    centavos: Math.round(num * 100) - Math.floor(num) * 100,
  };

  var centavosString = data.centavos.toString();

  if (centavosString.length === 1) {
    centavosString = "0" + centavosString;
  }

  if (data.enteros === 0) return "CERO Y " + centavosString + "/100";
  else return Millones(data.enteros) + " Y " + centavosString + "/100";
};

export const FormasPago = {
  contado: { label: "Contado", value: "Contado" },
  credito: { label: "Crédito", value: "Credito" },
};

export const getCurrentDate = () => {
  let today = new Date();
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  let yyyy = today.getFullYear();
  return yyyy + "-" + mm + "-" + dd;
};



export const getCuoteNumber = (length: number) => {
  const nextLength = length + 1;
  if (nextLength < 10) {
    return "Cuota00" + nextLength;
  }
  if (nextLength < 100) {
    return "Cuota0" + nextLength;
  }
  return nextLength;
};

export const getAffectation = (affectation: string) => {
  switch(affectation) {
    case 'IGV': return "10";
    case 'INA': return "30";
    case 'EXO': return "20"    
    case 'Gratuito': return "37";
    default: return "11";
  }
}

export const statusPayment=(status:string, fecha:any)=>{
  const dateNow = moment().format('YYYY-MM-DD HH:mm:ss');
  const chargeExpired = moment(fecha).format('YYYY-MM-DD HH:mm:ss')
 
      if (status!=="pagado" && dateNow > chargeExpired) {
        status="expirado";
      }

  switch (status) {
    case "expirado":
    return "expirado"; 

    case "progreso":
      return "pendiente";

    case "pagado":
      return "pagado"; 

    case "pendiente":
      return "pendiente";

    case "cancelado":
      return "pendiente";
      
    case "fallido":
      return "pendiente";

    case "disponible":
      return "pendiente";

    default:
      return "";
  }
}